import React, { useState } from 'react';

const Enter = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    category: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        companyName: '',
        contactPerson: '',
        email: '',
        phone: '',
        category: '',
        message: ''
      });
    }, 3000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const categories = [
    'Banking Award',
    'Forex Brokers Award',
    'Insurance Award',
    'Stock Broker Award',
    'Real Estate Award',
    'Beauty Award',
    'Tourist Award',
    'Influencer Award'
  ];

  return (
    <div className="enter-page">
      <div className="enter-container">
        <h1 className="page-title">ENTER THE COMPETITION</h1>
        <p className="page-intro">
          Submit your application for the World Financial Award 2026. Fill out the form below to enter 
          the competition and get the recognition your company deserves.
        </p>

        <form onSubmit={handleSubmit} className="entry-form">
          <div className="form-row">
            <div className="form-group">
              <label>Company Name *</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Contact Person *</label>
              <input
                type="text"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Award Category *</label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
              className="form-select"
            >
              <option value="">Select a category</option>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Additional Information</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="6"
              className="form-textarea"
              placeholder="Tell us why your company deserves this award..."
            />
          </div>

          <button type="submit" className="submit-btn-large">
            {submitted ? 'Submitted Successfully!' : 'Submit Application'}
          </button>
        </form>

        {submitted && (
          <div className="success-message-large">
            <p>Thank you! Your application has been submitted successfully.</p>
            <p>Our team will review your submission and contact you soon.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Enter;
